import * as React from 'react';

import GenToggleButton from './ToggleButton'

interface GenToggleBarProps {
  onClick: (value: string) => void
  buttons: Array<{
    disabled: boolean;
    name: string;
    value: string;
  }>;
  value: string;
  disabled: boolean;
}

export default function GenToggleBar(props: GenToggleBarProps) {
  const onClickFunction = (value: string) => {
    return () => { props.onClick(value) };
  };

  let toggleButtons = props.buttons.map((button) => {
    return (
      <GenToggleButton
        key={button.name}
        name={button.name}
        value={button.value === props.value}
        disabled={props.disabled || button.disabled}
        onClick={onClickFunction(button.value)} />
    );
  });

  return(
    <div className="gen-toggle-bar">
      {toggleButtons}
    </div>
  );
}
